import EmployeesTable from "../../Employees/Confie/views/EmployeesTable";
const OfficeEmployeeTable = ({ data }) => {
  const officeCode =
    data?.officeCode === null || data?.officeCode === ""
      ? "No OfficeCode"
      : data.officeCode;
  return (
    <div className="w-full borderContainer p-2 bg-white">
      <div className="overflow-x-auto px-6">
        <EmployeesTable officeCode={officeCode} viewFromOffice={true} />
      </div>
    </div>
  );
};

export default OfficeEmployeeTable;
